export const getInventoryProductColumnDefaults = () => ({
  reference: true,
  image: true,
  label: true,
  sku: false,
  inventories: false,
  supplier: false,
  category: false,
  purchase_price: false,
  price: true,
  profit_margin: false,
  quantity: true,
  min_quantity: false,
  warehouse: false,
  status: true,
  created_by: false,
  created_at: false,
  action: true,
  barcode: false,
  has_variants: false,
  notes: false,
  unity: false
})
